import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";

const AdminHeader = ({ sidebarOpen, setSidebarOpen }) => {
  const [showMobileSearch, setShowMobileSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const location = useLocation();

  // Fungsi untuk mendapatkan judul halaman berdasarkan path
  const getPageTitle = () => {
    const path = location.pathname;
    if (path.includes("/admin/dashboard")) return "Dashboard";
    if (path.includes("/admin/products")) return "Manajemen Produk";
    if (path.includes("/admin/categories")) return "Kategori Produk";
    if (path.includes("/admin/articles")) return "Manajemen Artikel";
    if (path.includes("/admin/gallery")) return "Manajemen Galeri";
    if (path.includes("/admin/users")) return "Manajemen Pengguna";
    if (path.includes("/admin/settings")) return "Pengaturan";
    return "Admin";
  };

  return (
    <>
      {/* Mobile Search Overlay */}
      {showMobileSearch && (
        <div
          className="fixed inset-0 bg-black/50 z-50 md:hidden"
          onClick={() => setShowMobileSearch(false)}
        >
          <div
            className="absolute top-16 left-0 right-0 bg-white p-4 border-b border-gray-200"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-400">
                <span className="material-symbols-outlined text-xl">
                  search
                </span>
              </div>
              <input
                type="text"
                placeholder="Cari produk, artikel, atau pengguna..."
                className="block w-full pl-10 pr-3 py-2 border border-gray-200 bg-gray-50 rounded-xl text-neutral-black placeholder-gray-400 focus:ring-2 focus:ring-primary focus:border-primary focus:bg-white text-sm transition-all outline-none"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                autoFocus
              />
            </div>
          </div>
        </div>
      )}

      {/* Header */}
      <header className="sticky top-0 z-30 bg-white/80 dark:bg-[#0f0f0e]/80 backdrop-blur-md border-b border-gray-200 dark:border-white/5 transition-all duration-300">
        <div className="flex items-center justify-between h-20 px-6 md:px-10">
          <div className="flex items-center gap-6 flex-1">
            {/* Mobile Menu Button - Redesigned */}
            <button
              onClick={() => setSidebarOpen(!sidebarOpen)}
              className="md:hidden p-3 rounded-xl bg-gray-100 dark:bg-white/5 text-[#171612] dark:text-white hover:scale-105 transition-all active:scale-95"
            >
              <span className="material-symbols-outlined font-bold">menu</span>
            </button>

            {/* Desktop Search - Premium Look */}
            <div className="hidden md:block max-w-lg flex-1">
              <div className="relative group">
                <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none text-gray-400 group-focus-within:text-[#d4af35] transition-colors">
                  <span className="material-symbols-outlined text-xl font-bold">search</span>
                </div>
                <input
                  className="block w-full pl-12 pr-6 py-3.5 bg-gray-100 dark:bg-white/5 border border-transparent focus:border-[#d4af35]/30 focus:bg-white dark:focus:bg-[#171612] text-[#171612] dark:text-white placeholder-gray-500 rounded-2xl text-sm transition-all outline-none shadow-sm group-hover:bg-gray-200 dark:group-hover:bg-white/10"
                  placeholder="Ketik untuk mencari data atau fitur..."
                  type="text"
                />
              </div>
            </div>
          </div>

          <div className="flex items-center gap-3 md:gap-6">
            {/* Actions / Notifications - Placeholder for Premium Look */}
            <div className="flex items-center gap-1 md:gap-2">
              <button 
                onClick={() => setShowMobileSearch(true)}
                className="md:hidden p-2.5 rounded-xl text-gray-400 hover:text-[#171612] dark:hover:text-white hover:bg-gray-100 dark:hover:bg-white/5 transition-all"
              >
                <span className="material-symbols-outlined">search</span>
              </button>
              <button className="p-2.5 rounded-xl text-gray-400 hover:text-[#171612] dark:hover:text-white hover:bg-gray-100 dark:hover:bg-white/5 transition-all relative">
                <span className="material-symbols-outlined">notifications</span>
                <span className="absolute top-2.5 right-2.5 w-2 h-2 bg-[#d4af35] rounded-full border-2 border-white dark:border-[#0f0f0e]"></span>
              </button>
              <button className="p-2.5 rounded-xl text-gray-400 hover:text-[#171612] dark:hover:text-white hover:bg-gray-100 dark:hover:bg-white/5 transition-all">
                <span className="material-symbols-outlined">settings</span>
              </button>
            </div>

            <div className="h-8 w-[1px] bg-gray-200 dark:bg-white/10 mx-2 hidden md:block"></div>

            {/* User Profile - Premium Display */}
            <div className="flex items-center gap-4 pl-2 cursor-pointer group">
              <div className="hidden md:block text-right overflow-hidden">
                <p className="text-[#171612] dark:text-white text-xs font-black tracking-tight leading-none mb-1 group-hover:text-[#d4af35] transition-colors">Administrator</p>
                <p className="text-gray-500 dark:text-gray-400 text-[10px] font-bold uppercase tracking-wider">Super Admin</p>
              </div>
              <div className="relative">
                <div className="size-11 rounded-2xl bg-gradient-to-br from-[#d4af35] to-[#bfa030] p-[2px] shadow-lg shadow-[#d4af35]/10 group-hover:scale-105 transition-transform duration-300">
                  <div className="w-full h-full rounded-[14px] bg-white dark:bg-[#171612] overflow-hidden flex items-center justify-center border border-white/10">
                    <img loading="lazy" 
                      src="https://placehold.co/80x80/d4af35/171612?text=AD" 
                      alt="Admin" 
                      className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-500"
                    />
                  </div>
                </div>
                <div className="absolute -bottom-1 -right-1 size-4 bg-green-500 rounded-lg border-4 border-white dark:border-[#0f0f0e]"></div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default AdminHeader;
